export default __webpack_public_path__ + "mini-icon-ios-15@2x.png";